import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions as userV2Actions } from './userSliceV2';
import { UserStateV2 } from '../../app/Subscriptions/types/UserStateV2';
import { RootState } from '../state';

export function useMigrateUserData() {
    const dispatch = useDispatch();
    const oldUserData = useSelector((state: RootState) => state.userSlice);
    const newUserData = useSelector((state: RootState) => state.userSliceV2);

    useEffect(() => {
        // Only migrate if we have old data and no new data
        if (oldUserData && oldUserData.isAuthenticated && !newUserData.data?.isAuthenticated) {
            const migratedData: UserStateV2 = {
                uid: oldUserData.uid || '',
                userId: oldUserData.userId || '',
                phone_number: oldUserData.phone_number || '',
                display_name: oldUserData.display_name || '',
                email: oldUserData.email || '',
                photo_url: oldUserData.photo_url || '',
                isAuthenticated: oldUserData.isAuthenticated || false,
                loading: oldUserData.loading || false,
                error: oldUserData.error || null,
                created_time: oldUserData.created_time || new Date().toISOString(),
                edited_time: oldUserData.edited_time || new Date().toISOString(),
                businessProfile: oldUserData.businessProfile || { businessName: '', businessType: '' },
                delegatedRoles: oldUserData.delegatedRoles || [],
                addDummySubscription: oldUserData.addDummySubscription || false,
                notifyOnWhatsApp: oldUserData.notifyOnWhatsApp || false,
                Credits: oldUserData.Credits || 0,
                myRoles: oldUserData.myRoles || [],
                ServiceTypes: oldUserData.ServiceTypes || [],
                plundrDescription: oldUserData.plundrDescription || '',
                plundrImages: oldUserData.plundrImages || [],
                pauseBySubscriber: oldUserData.pauseBySubscriber || false,
                GSTIN: oldUserData.GSTIN || '',
                mmAlign2monthBoundary: oldUserData.mmAlign2monthBoundary || false,
                unmaskCustomerNumbers: oldUserData.unmaskCustomerNumbers || false,
                multiMonthPlanToDaysTable: oldUserData.multiMonthPlanToDaysTable || {
                    Annual: 0,
                    FlexibleMonthly: 0,
                    Quarterly: 0,
                    Semester: 0
                },
                paymentProfiles: oldUserData.paymentProfiles || null
            };

            dispatch(userV2Actions.setOtherDetails({ uid: migratedData.uid }));
            dispatch(userV2Actions.success(migratedData));
            // Optionally, log migration for monitoring
            console.log('User data migrated to V2');
        }
    }, [oldUserData, newUserData, dispatch]);
} 